const initialState = {
	BASE_URL: undefined,
	CONTENT_API_URL: undefined,
	USER_AUTH_API_URL: undefined,
	QUOTE_API_URL: undefined,
	FACEBOOK_APP_ID: undefined,
	OAUTH_API_URL: undefined,
	GOOGLE_API_KEY: undefined,
	GTM_ID: undefined,
	ADYEN_API_KEY: undefined,
	NAV_LOGS_API_URL: undefined,
	AB_TASTY_CODE: undefined,
	ENVIRONMENT: undefined,
	ONE_TRUST_SCRIPT: undefined,
};

export default (envVars = initialState) => {
	return envVars;
};
